import React, { useState } from 'react';
import StandardsProgression from '../StandardsProgression';
import LearningTaskCard from './LearningTaskCard';

export default function CreateLearningTask() {
  const [selections, setSelections] = useState<any>(null);
  const [choosingStandards, setChoosingStandards] = useState<any>(true);

  return (
    <>
      <div hidden={!choosingStandards}>
        <StandardsProgression taskCreation onTaskContinue={standards => {
          setSelections(standards);
          setChoosingStandards(false);
          window.scrollTo({ top: 0, behavior: 'auto' });
        }} />
      </div>
      {selections && (
        <div hidden={choosingStandards}>
          <LearningTaskCard taskSelections={selections} onChooseStandards={() => {
            setChoosingStandards(true);
            window.scrollTo({ top: 0, behavior: 'auto' });
          }} />
        </div>
      )}
    </>
  );
}
